import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { xesCookie } from './lib/xes/xes-lib';
// import autoViewport from './lib/xes/viewport';

// 尝试覆盖onbeforeunload
window.onbeforeunload = () => {}
document.onbeforeunload = () => {}

// 设置中文
xesCookie.setCookie('IntlLang', 'zh')
// 定义公用全局变量
window.Xes = {}

document.body.addEventListener('click', function (event) {
  const target = event.target
  if (target.innerText === '成为慧编程开发者，扩展更多可能性') {
    event.stopPropagation()
  }
  if (
    target.tagName.toLowerCase() === 'a' &&
    [...target.classList].includes('name') &&
    target.parentNode.tagName.toLowerCase() === 'div' &&
    [...target.parentNode.classList].includes('title')
  ) {
    event.stopPropagation()
  }
  if (
    target.tagName.toLowerCase() === 'a' &&
    [...target.classList].includes('device-name') &&
    target.parentNode.tagName.toLowerCase() === 'div' &&
    [...target.parentNode.classList].includes('device-name-inner')
  ) {
    event.stopPropagation()
  }

  /* 右下角LOGO 阻止点击跳转 */
  if(
    target.tagName.toLowerCase() === 'img' && 
    target.src.includes('icon-copyright.png')
  ){
    target.parentNode.target = "_self"
  }
}, {
  capture: true
})

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
